module.exports = __webpack_public_path__ + "img/Disc roter.71a2601b.jpg";